"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _chevronRightSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-right-small"));
var _chevronRight = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-right"));
var _arrowRight = _interopRequireDefault(require("@ingka/ssr-icon/paths/arrow-right"));
var _linkOut = _interopRequireDefault(require("@ingka/ssr-icon/paths/link-out"));
var _checkbox = _interopRequireDefault(require("@ingka/checkbox"));
var _radioButton = _interopRequireDefault(require("@ingka/radio-button"));
var _switch = _interopRequireDefault(require("@ingka/switch"));
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _image = _interopRequireDefault(require("@ingka/image"));
var _aspectRatioBox = _interopRequireDefault(require("@ingka/aspect-ratio-box"));
var _paymentLogo = _interopRequireDefault(require("@ingka/payment-logo"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ListViewItem = (0, _react.forwardRef)((props, ref) => {
  const {
    prefix = '',
    id,
    control = 'default',
    name,
    onClick,
    onChange,
    title,
    description,
    addOn,
    leadingIcon,
    image,
    imageAltText = '',
    paymentLogo,
    size = 'medium',
    inset,
    emphasised,
    disabled,
    className,
    controlProps,
    imageProps,
    quantityLabel,
    href,
    newWindow,
    controlIcon = 'linkOut',
    leadingIconPosition = 'center',
    showDivider = true,
    ...otherProps
  } = props;
  let elementTag;
  switch (control) {
    case 'navigational':
      elementTag = 'button';
      break;
    case 'link':
      elementTag = 'a';
      break;
    case 'default':
      elementTag = 'span';
      break;
    default:
      elementTag = 'label';
      break;
  }
  const baseClass = `${prefix}list-view-item`;
  const controlId = id + '__control';
  const controlTypes = {
    DEFAULT: 'default',
    CHECKBOX: 'checkbox',
    RADIOBUTTON: 'radiobutton',
    SWITCH: 'switch',
    NAVIGATIONAL: 'navigational',
    LINK: 'link'
  };
  const classes = (0, _classnames.default)(baseClass, disabled && control !== controlTypes.DEFAULT && `${baseClass}--disabled`, !showDivider && `${baseClass}__no-divider`, className);
  const itemClasses = (0, _classnames.default)(control === controlTypes.DEFAULT ? `${baseClass}__default` : `${baseClass}__action`, inset && `${baseClass}__inset`, image && `${baseClass}__with-image`);
  const trailingIcon = {
    chevronRight: _chevronRight.default,
    chevronRightSmall: _chevronRightSmall.default,
    arrowRight: _arrowRight.default,
    linkOut: _linkOut.default
  };
  const controlOptsMap = {
    [controlTypes.CHECKBOX]: _react.default.createElement(_checkbox.default, _extends({
      subtle: true,
      id: controlId,
      name: name,
      disabled: disabled,
      onChange: onChange,
      prefix: prefix
    }, controlProps)),
    [controlTypes.RADIOBUTTON]: _react.default.createElement(_radioButton.default, _extends({
      subtle: true,
      id: controlId,
      name: name,
      disabled: disabled,
      onChange: onChange,
      prefix: prefix
    }, controlProps)),
    [controlTypes.SWITCH]: _react.default.createElement(_switch.default, _extends({
      subtle: true,
      id: controlId,
      name: name,
      disabled: disabled,
      onChange: onChange,
      prefix: prefix
    }, controlProps)),
    [controlTypes.NAVIGATIONAL]: trailingIcon[controlIcon] && _react.default.createElement("span", {
      className: `${baseClass}__control-icon`
    }, _react.default.createElement(_ssrIcon.default, {
      prefix: prefix,
      paths: trailingIcon[controlIcon]
    })),
    [controlTypes.LINK]: trailingIcon[controlIcon] && _react.default.createElement("span", {
      className: `${baseClass}__control-icon`
    }, _react.default.createElement(_ssrIcon.default, {
      prefix: prefix,
      paths: trailingIcon[controlIcon]
    }))
  };
  const leadingOptsMap = {
    ['image']: _react.default.createElement("span", {
      className: `${baseClass}__image`
    }, _react.default.createElement(_aspectRatioBox.default, {
      prefix: prefix,
      ratio: "square"
    }, _react.default.createElement(_image.default, _extends({
      src: image,
      prefix: prefix,
      alt: imageAltText
    }, imageProps)))),
    ['icon']: _react.default.createElement(_ssrIcon.default, {
      prefix: prefix,
      className: `${baseClass}__icon-${leadingIconPosition}`,
      paths: leadingIcon
    }),
    ['paymentLogo']: _react.default.createElement(_paymentLogo.default, _extends({
      prefix: prefix,
      className: `${baseClass}__payment-logo`,
      size: size === 'small' ? 'small' : 'medium'
    }, paymentLogo))
  };
  const controlType = controlOptsMap[control];
  let leadingMedia = null;
  if (image) {
    leadingMedia = leadingOptsMap.image;
  } else if (paymentLogo && !image) {
    leadingMedia = leadingOptsMap.paymentLogo;
  } else if (leadingIcon && !image && !paymentLogo) {
    leadingMedia = leadingOptsMap.icon;
  }
  const ActionElementTag = elementTag;
  return _react.default.createElement("li", {
    id: id,
    ref: ref,
    className: classes
  }, _react.default.createElement(ActionElementTag, _extends({
    className: itemClasses,
    onClick: !disabled && control === controlTypes.NAVIGATIONAL ? onClick : null,
    href: control === controlTypes.LINK && href && !disabled ? href : null,
    target: control === controlTypes.LINK && href && newWindow && !disabled ? newWindow : null
  }, otherProps, {
    disabled: control === controlTypes.NAVIGATIONAL && disabled
  }), _react.default.createElement("span", {
    className: `${baseClass}__wrapper`
  }, leadingMedia, _react.default.createElement("span", {
    className: `${baseClass}__label-container`
  }, _react.default.createElement("span", {
    className: (0, _classnames.default)(`${baseClass}__title`, emphasised && `${baseClass}__title--emphasised`)
  }, title), description && size !== 'small' && _react.default.createElement("span", {
    className: `${baseClass}__description`
  }, description), addOn && size !== 'small' && _react.default.createElement("span", {
    className: `${baseClass}__addon`
  }, addOn))), quantityLabel && _react.default.createElement("span", {
    className: `${baseClass}__quantity-label`
  }, quantityLabel), controlType));
});
ListViewItem.displayName = 'ListViewItem';
var _default = ListViewItem;
exports.default = _default;